/**
 * @copyright 2026 @ DigiNet
 * @author YENNHI
 * @create 16/06/2026
 * @update 16/06/2026
 */

import { Column } from "devextreme-react/data-grid";
import { Checkbox, Col, DatePicker, Row, TextInput } from 'diginet-core-ui/components';
import React, { useEffect, useMemo, useRef, useState } from 'react';
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import * as W06F4210Actions from "../../../actions/w06/W06F4210/W06F4210-actions";
import Config from "../../../config";
import MForm from "../../common/form/form";
import GridContainer from "../../common/grid-container/grid-container";
import W2W from "../../common/w2w/index";

const FormID = 'W06F4210';
const initialDataMaster = {
    IsPurchase: 1,
    IsOrderSales: 0,
    DateFrom: null,
    DateTo: null,
    ID: '',
    Name: '',
};
const requiredArr = ['ID'];

const W06F4210 = (props) => {
    const [mode, _setMode] = useState('view'); // Mặc định mode View
    const [isChangeForm, setIsChangeForm] = useState(false);
    const [formLoading, setFormLoading] = useState(false);
    const [error, setError] = useState({});
    const [dataMaster, setDataMaster] = useState({ ...initialDataMaster });
    const [dataGridRight, setDataGridRight] = useState([]);
    //===================useRef====================
    const w2wRef = useRef(null);
    const gridRightRef = useRef(null);
    const modeRef = useRef(mode);
    const readOnly = modeRef.current === 'view';

    useEffect(() => {
        if (mode === 'add') onNext();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [mode]);

    const loadDataGeneral = (modeLoad, paramPlus) => {
        gridParam(modeLoad, true);
        props.W06F4210Actions.loadForm(gridParam(modeLoad, false, paramPlus), (err, data) => {
            gridParam(modeLoad, false);
            if (err) {
                Config.popupCore.show('ERROR', err);
                return false;
            } else if (data) {
                gridParam(modeLoad, data);
            }
        });
    };

    const getModeParam = () => {
        let result = 0;
        switch (modeRef.current) {
            case 'edit':
            case 'view':
                result = 1;
                break;
            case 'copy':
                result = 2;
                break;
            default:
                break;
        }
        return result;
    };

    const gridParam = (type, status, paramPlus) => {
        let DataTypeID = '';
        const result = {
            Mode: 0,
            ID: '',
            StrSearch: ''
        };
        switch (type) {
            case 'loadGrid':
                delete result.StrSearch;
                DataTypeID = 'LoadForm_1';
                break;
            case 'loadForm':
                if (paramPlus) result.ID = paramPlus.ID;
                DataTypeID = 'LoadForm_2';
                result.Mode = getModeParam();
                if (!Config.typeOf(status, 'undefined')) {
                    if (Config.typeOf(status, 'boolean')) setFormLoading(status);
                    else {
                        setDataMaster(status?.table1 || {});
                        setDataGridRight(status?.table2 || []);
                    }
                }
                break;
            case 'isUsed':
                DataTypeID = 'Disabled';
                break;
            case 'delete':
                DataTypeID = 'Delete';
                break;
            case 'save':
                DataTypeID = 'Save';
                break;
            default:
                break;
        }
        result.DataTypeID = DataTypeID;
        return result
    };

    const setDataMasterState = (obj = {}) => {
        setDataMaster({ ...dataMaster, ...obj });
    };

    const onChangeRow = (data = {}) => {
        if (!Config.isEmpty(data)) {
            loadDataGeneral('loadForm', data);
        }
        setError({});
        setIsChangeForm(false);
    };

    const onNext = (setModeAdd = false) => { // Clear Form
        if (setModeAdd) setMode('add');
        setError({});
        setIsChangeForm(false);
        setDataMaster({ ...initialDataMaster }); // set lại default
    };

    const renderIsDisabledColumn = (e) => {
        const value = e?.data?.Disabled ?? 0;
        return <Checkbox
            readOnly
            style={{ margin: 'auto' }}
            className={'flex valign-middle'}
            checked={!!value}
        />;
    };

    const checkValidateMaster = (arrName) => {
        if (Config.isEmpty(arrName)) return;
        return arrName.map(item => {
            return {
                name: item,
                rules: ['isRequired'],
                value: dataMaster[item]
            }
        });
    };

    const onSave = async (filter) => {
        const resultValidate = checkValidateMaster(requiredArr);
        const validateForm = MForm.formValidation(resultValidate);
        if (Object.keys(validateForm).length > 0) {
            setError(validateForm);
            return false;
        } else {
            await gridRightRef.current.instance.saveEditData();
            const rows = gridRightRef.current?.instance?.getDataSource()?.items() || [];
            const selectedRows = rows.filter(x => x.Choose === 1);
            const params = {
                ...filter,
                ...dataMaster,
                data: JSON.stringify(selectedRows),
                Mode: getModeParam()
            };
            return {
                params,
                mode: mode,
                cb: () => {
                    setIsChangeForm(false);
                }
            };
        }
    };

    const onChange = (fieldName, e) => {
        if (Config.isEmpty(fieldName)) return;
        let objPlus = {};
        let value = (Config.typeOf(e, 'object') ? e?.value ?? e?.target?.value : e) ?? '';
        if (Config.typeOf(value, 'boolean')) value = +value;
        if (['DateTo', 'DateFrom'].includes(fieldName) && Config.isEmpty(value)) value = null;
        switch (fieldName) {
            case 'IsPurchase':
                objPlus = {
                    IsPurchase: value,
                    IsOrderSales: +!value
                };
                break;
            case 'IsOrderSales':
                objPlus = {
                    IsOrderSales: value,
                    IsPurchase: +!value
                };
                break;
            default:
                objPlus = { [fieldName]: value };
                break;
        }
        setIsChangeForm(true);
        setDataMasterState(objPlus);
        if (error[fieldName] && value) setError({ ...error, [fieldName]: '' });
    };

    const renderCheckColumn = (e) => {
        return <div className="display_row valign-middle align-center full_w">
            <Checkbox
                readOnly={readOnly}
                className="auto-margin"
                checked={!!e?.value}
                onChange={(event) => {
                    const value = event.target.checked;
                    e.component.cellValue(e.rowIndex, "Choose", +value);
                    e.component.saveEditData();
                }}

            />
        </div>
    };

    const renderGridRight = useMemo(() => {
        return (
            <GridContainer
                reference={ref => (gridRightRef.current = ref)}
                dataSource={dataGridRight}
                keyExpr={'InventoryID'}
                typePaging={'normal'}
                itemPerPage={30}
                elementAttr={{ style: 'min-height: 420px' }}
                listPerPage={[30, 60, 90, 120]}
                onRowUpdated={(e) => {
                    setIsChangeForm(true);
                }}
                filterRow={{
                    visible: true,
                    applyFilter: 'auto'
                }}
                editing={{
                    mode: 'cell',
                    refreshMode: 'reshape',
                    allowUpdating: !readOnly,
                    texts: { confirmDeleteMessage: '' },
                    startEditAction: 'click',
                }} >
                <Column
                    width={120}
                    alignment={'center'}
                    dataField={'Choose'}
                    allowEditing={false}
                    trueText={Config.lang('Co')}
                    falseText={Config.lang('Khong')}
                    caption={Config.lang('Chon')}
                    dataType={'boolean'}
                    calculateCellValue={(rowData) => !!rowData?.Choose}
                    cellRender={e => renderCheckColumn(e)}
                />
                <Column
                    width={280}
                    allowEditing={false}
                    dataField={'InventoryID'}
                    caption={Config.lang('Ma_hang')}
                />
                <Column
                    allowEditing={false}
                    dataField={'InventoryName'}
                    caption={Config.lang('Ten_hang')}
                />
                <Column
                    width={160}
                    allowEditing={false}
                    dataField={'UnitName'}
                    caption={Config.lang('Don_vi_tinh')}
                />
            </GridContainer>
        )
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [dataGridRight, readOnly]);

    const handleLoadAction = (params, cb, paramMode) => {
        const actions = {
            delete: props.W06F4210Actions.deleteRow,
            save: props.W06F4210Actions.save,
            loadGrid: props.W06F4210Actions.loadForm,
            isUsed: props.W06F4210Actions.deleteRow,
        };
        const action = actions[paramMode];
        if (!action) return;
        let payload = {
            ...gridParam(paramMode),
            ...params,
        };
        if (paramMode === 'save') {
            payload = {
                ...payload,
                Name: dataMaster?.Name || "",
                IsPurchase: dataMaster?.IsPurchase ?? 0,
                IsOrderSales: dataMaster?.IsOrderSales ?? 0,
                DateFrom: dataMaster?.DateFrom ?? null,
                DateTo: dataMaster?.DateTo ?? null,
                // data,
            };
        }
        return action(payload, (err, data) => {
            cb && cb(err, data);
        }
        );
    };

    const setMode = (mode) => {
        modeRef.current = mode;
        _setMode(modeRef.current);
        if (mode === 'add') loadDataGeneral('loadForm');
    };

    return (
        <W2W
            ref={w2wRef}
            FormID={FormID} // FormID của màn hình để truyền vào params của các API phân quyền, Lưu lịch sử checkbox disabled, xóa
            isChanged={isChangeForm} // State quản lý dữ liệu cột bên phải đã thay đổi
            mode={mode}
            updateMode={(mode) => setMode(mode)}
            checkboxHidden
            action={{
                loadGrid: (params, cb) => handleLoadAction(params, cb, 'loadGrid'), // action load lưới trái
                add: (params, cb) => handleLoadAction(params, cb, 'save'), // action save thêm dòng mới
                edit: (params, cb) => handleLoadAction(params, cb, 'save'), // action save sửa dòng
                copy: (params, cb) => handleLoadAction(params, cb, 'save'), // action save sửa dòng
                delete: (params, cb) => handleLoadAction(params, cb, 'delete'), // action xóa dòng
                isUsed: (params, cb) => handleLoadAction(params, cb, 'isUsed'), // action sử dụng
            }}
            actionToolbar={{ // title của ActionToolbar 
                title: Config.lang('Danh_sach_mat_hang_duoc_phep_mua_dat_hang'),
            }}
            titleRight={Config.lang('Chi_tiet_mat_hang_duoc_phep_mua_dat_hang')}
            onSelectedRow={onChangeRow}
            keyExpr={'ID'}
            onSave={onSave} // Xử lý sự kiện lưu
            loading={formLoading}
            leftCol={{ // Số cột hiển thị của lưới bên trái
                xs: 12,
                sm: 12,
                md: 5,
                lg: 5,
            }}
            dataColumnGrid={[ // Các cột của lưới trái 
                {
                    width: 200,
                    dataField: 'ID',
                    caption: Config.lang('Ma'),
                },
                {
                    width: 380,
                    dataField: 'Name',
                    caption: Config.lang('Ten')
                },
                {
                    width: 120,
                    dataType: 'boolean',
                    dataField: 'Disabled',
                    caption: Config.lang('Khong_su_dung'),
                    trueText: Config.lang('Co'),
                    falseText: Config.lang('Khong'),
                    cellRender: renderIsDisabledColumn,
                    calculateCellValue: (rowData) => !!rowData?.Disabled
                }
            ]}>
            {/* Cột bên phải */}
            <Row>
                <Col xs={12} sm={12} md={12} lg={12}>
                    <Row className="display_row valign-top align-center">
                        <Col xs={3} sm={3} md={3} lg={3}>
                            <Checkbox
                                readOnly={readOnly}
                                label={Config.lang("Mua_hang")}
                                className={'flex valign-middle'}
                                checked={!!dataMaster?.IsPurchase}
                                onChange={e => onChange('IsPurchase', e)}
                            />
                        </Col>
                        <Col xs={9} sm={9} md={9} lg={9}>
                            <Checkbox
                                readOnly={readOnly}
                                label={Config.lang("Dat_hang")}
                                className={'flex valign-middle'}
                                checked={!!dataMaster?.IsOrderSales}
                                onChange={e => onChange('IsOrderSales', e)}
                            />
                        </Col>
                    </Row>
                </Col>
                <Col xs={12} sm={12} md={6} lg={6} verticalAlign={'end'}>
                    <TextInput
                        required
                        readOnly={readOnly}
                        disabled={mode === 'edit'}
                        label={Config.lang('Ma')}
                        value={dataMaster?.ID}
                        error={error && error['ID']}
                        onChange={e => onChange('ID', e)}
                    />
                </Col>
                <Col xs={12} sm={12} md={6} lg={6} verticalAlign={'end'}>
                    <TextInput
                        readOnly={readOnly}
                        label={Config.lang('Ten')}
                        value={dataMaster?.Name}
                        onChange={e => onChange('Name', e)}
                    />
                </Col>
                <Col xs={12} sm={12} md={6} lg={6} verticalAlign={'end'}>
                    <DatePicker
                        clearAble
                        label={Config.lang('Hieu_luc_tu')}
                        readOnly={readOnly}
                        displayFormat={"DD/MM/YYYY"}
                        max={dataMaster.DateTo}
                        value={dataMaster?.DateFrom}
                        onChange={e => onChange('DateFrom', e)}
                    />
                </Col>
                <Col xs={12} sm={12} md={6} lg={6} verticalAlign={'end'}>
                    <DatePicker
                        clearAble
                        label={Config.lang('Hieu_luc_den')}
                        readOnly={readOnly}
                        displayFormat={"DD/MM/YYYY"}
                        min={dataMaster.DateFrom}
                        value={dataMaster?.DateTo}
                        onChange={e => onChange('DateTo', e)}
                    />
                </Col>
                <Col xs={12}>{renderGridRight}</Col>
            </Row>
        </W2W>
    )
};

export default connect(null, (dispatch) => ({
    W06F4210Actions: bindActionCreators(W06F4210Actions, dispatch),
}))(W06F4210);


